import React from "react";

/**
 * ErrorBoundary global (Fase 6 — suporte ao code-splitting).
 *
 * Captura erros de render. Em especial trata ChunkLoadError: quando uma rota
 * lazy falha ao baixar seu chunk. O caso mais comum e POS-DEPLOY — uma aba
 * aberta ha horas tem o index.html antigo e tenta baixar um chunk com hash que
 * o deploy novo ja removeu (404). Recarregar resolve (pega index + chunks
 * novos). Para os demais erros, mostra um fallback amigavel com "Recarregar"
 * em vez de tela branca.
 *
 * Estilo inline proposital: nao depende de styled-components nem de nenhum
 * chunk que possa ser justamente o que falhou ao carregar.
 */
const CHUNK_RELOAD_FLAG = "dash-erp:chunk-reload";

function ehErroDeChunk(erro) {
  const txt = `${(erro && erro.name) || ""} ${(erro && erro.message) || ""}`;
  return /ChunkLoadError|Loading chunk|Loading CSS chunk/i.test(txt);
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { temErro: false, ehChunk: false };
  }

  static getDerivedStateFromError(erro) {
    return { temErro: true, ehChunk: ehErroDeChunk(erro) };
  }

  componentDidCatch(erro) {
    // Auto-reload 1x por sessao para ChunkLoadError pos-deploy. O flag evita
    // loop infinito se o erro persistir (ex.: chunk realmente quebrado).
    if (ehErroDeChunk(erro)) {
      try {
        if (!window.sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
          window.sessionStorage.setItem(CHUNK_RELOAD_FLAG, "1");
          window.location.reload();
        }
      } catch {
        /* sessionStorage indisponivel — segue para o fallback visual */
      }
    }
  }

  render() {
    if (!this.state.temErro) return this.props.children;

    return (
      <div
        role="alert"
        style={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          padding: 24,
          textAlign: "center",
          fontFamily: "system-ui, sans-serif",
          color: "#374151",
        }}
      >
        <h2 style={{ margin: 0, fontSize: 18 }}>
          {this.state.ehChunk
            ? "Saiu uma versão nova do sistema."
            : "Algo deu errado ao carregar esta tela."}
        </h2>
        <p style={{ margin: 0, color: "#6b7280", maxWidth: 420 }}>
          {this.state.ehChunk
            ? "Recarregue a página para pegar a versão atualizada."
            : "Tente recarregar. Se persistir, avise o suporte."}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: "10px 20px",
            borderRadius: 8,
            border: "none",
            background: "#b87333",
            color: "#fff",
            fontSize: 14,
            cursor: "pointer",
          }}
        >
          Recarregar
        </button>
      </div>
    );
  }
}
